import styles from './InfoFormacoes.module.css'
import { MdWatchLater } from 'react-icons/md'
import { GrCertificate, GrArticle } from 'react-icons/gr'

export default function InfoFormacoes({ escola, tempo, cursos, artigos }) {
  return (
    <div className={styles.container}>
      <p className={styles.texto}>{escola}</p>
      <MdWatchLater size={25} className={styles.icon} />
      <p className={styles.texto}><strong>{tempo}</strong> Para conclusão</p>
      <GrCertificate size={25} className={styles.icon} />
      <p className={styles.texto}><strong>{cursos}</strong> Cursos</p>
      <GrArticle size={25} className={styles.icon} />
      <p className={styles.texto}><strong>{artigos}</strong>Artigos</p>
    </div>
  )
}
